<dx-pie-chart
  class="pie"
  palette="bright"
  [dataSource]="data[0].data">
  <dxo-title text="Nombre de Tracteur MP et GP de Belfaa">
    <dxo-font [weight]="300" [size]="18"></dxo-font>
  </dxo-title>
  <!--<dxo-adaptive-layout [height]="300" [width]="400"></dxo-adaptive-layout>-->
  <dxo-legend
    orientation="horizontal"
    itemTextPosition="right"
    horizontalAlignment="center"
    verticalAlignment="bottom"
    [columnCount]="4"></dxo-legend>
  <dxo-export [enabled]="false"></dxo-export>
  <dxi-series
    argumentField="type"
    valueField="count">
    <dxo-label
      [visible]="true"
      [customizeText]="customizeLabel">
      <!--<dxo-font [size]="16"></dxo-font>-->
      <dxo-connector
        [visible]="true"
        [width]="0.5"></dxo-connector>
    </dxo-label>
  </dxi-series>
</dx-pie-chart>
